import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      fillRule="evenodd"
      d="M10.302 12.394a.7.7 0 0 0-.008-.99L7.237 8.402l3.054-3.003a.7.7 0 1 0-.981-.998L5.85 7.803a.84.84 0 0 0 0 1.198l3.461 3.401a.7.7 0 0 0 .99-.008Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
